<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-md-12 mb-3">
          <label class="d-block">
            {{ $t('class-attendance-report-for-admin.absent_status') }}
          </label>
          <select
            v-model="model.selected_key"
            class="form-control"
            @change="setAttendance"
          >
            <option value="" disabled>{{ $t('select') }}</option>
            <option v-for="key in attendanceKeys" :key="key" :value="key">
              {{ key.charAt(0).toUpperCase() + key.slice(1) }}
            </option>
          </select>
        </div>

        <!-- <div class="col-md-12 mb-3" v-show="model.att_status_id == 1">
          <label class="d-block">
            {{ $t('class-attendance-report-for-admin.absent_status_present') }}
          </label>
          <select
            v-model="model.present_status_id"
            class="form-control"
          >
            <option value="" disabled>{{ $t('select') }}</option>
            <option
              v-for="option in presentOptions"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>
        </div> -->

        <div class="col-md-12 mb-3">
          <label class="d-block required">
            {{ $t('class-attendance-report-for-admin.comments') }}
          </label>
          <textarea
            v-model="model.comments"
            class="form-control"
            rows="3"
            :class="{ 'is-invalid': errors.has('comments') }"
          ></textarea>
          <div class="invalid-feedback" v-if="errors.has('comments')">
            {{ errors.first('comments') }}
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-12 d-flex justify-content-end ts-space-x-3">
          <ts-button @click="$emit('cancel')">
            {{ $t('cancel') }}
          </ts-button>
          <ts-button color="primary" @click="onUpdate">
            {{ $t('update') }}
          </ts-button>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import { isEmpty } from 'lodash'
export default {
  name: 'FormAction',
  data() {
    return {
      loading: false,
      settingData: false,
      errors: new Errors(),
      attendanceKeys: ['present', 'absent', 'permission', 'late'],
      model: {
        selected_key: null, // 'present', 'absent', etc.
        att_status_id: 1, // Always 1
        present_status_id: null, // Set based on selection
        comments: null
      }
    }
  },
  created() {
    this.fetchResourceBeforeCreate()
  },
  computed: {
    ...mapState('classAttendanceReport', ['edit_data'])
  },
  methods: {
    async fetchResourceBeforeCreate() {
      this.loading = true
      await this.$store
        .dispatch('classAttendanceReport/dataBeforeCreate')
        .then(() => {
          this.loading = false
          this.setEditData()
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },

    setAttendance() {
      const key = this.model.selected_key

      switch (key) {
        case 'present':
          this.model.att_status_id = 1
          this.model.present_status_id = 1
          break
        case 'absent':
          this.model.att_status_id = 2
          this.model.present_status_id = null
          break
        case 'permission':
          this.model.att_status_id = 3
          this.model.present_status_id = null
          break
        case 'late':
          this.model.att_status_id = 1
          this.model.present_status_id = 2
          break
        default:
          this.model.att_status_id = null
          this.model.present_status_id = null
      }
    },
    setEditData() {
      console.log(this.edit_data);
      if (!isEmpty(this.edit_data)) {
        const key = this.getKeyFromStatus(
          this.edit_data.att_status_id,
          this.edit_data.present_status_id
        )

        if (key && this.attendanceKeys.includes(key)) {
          this.model.selected_key = key
          this.setAttendance()
        }

        this.model.comments = this.edit_data.comments || null
      }
    },

    getKeyFromStatus(att_status_id, present_status_id) {
      if (att_status_id === 1 && present_status_id === 1) return 'present'
      if (att_status_id === 2 && present_status_id === null) return 'absent'
      if (att_status_id === 3 && present_status_id === null) return 'permission'
      if (att_status_id === 1 && present_status_id === 2) return 'late'
      return null
    },

    onUpdate() {
      this.errors = new Errors()
      this.loading = true
      this.$store
        .dispatch('classAttendanceReport/update', {
          id: this.edit_data.student_att_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.data.message)
          this.$emit('cancel')
        })
        .catch(err => {
          this.errors = new Errors(err.response.data.errors)
          this.$toasted.error(err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
